module.exports = __webpack_public_path__ + "static/media/leaf-footer.8b16f4e6.png";